import { PatternFormat } from "react-number-format";

interface PhoneNumberInputProps {
  label?: string;
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
}

export default function PhoneNumberInput({
  label,
  name,
  value,
  onChange,
  placeholder,
}: PhoneNumberInputProps) {
  return (
    <div className="w-full">
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-2">
          {label}
        </label>
      )}

      <PatternFormat
        format="+55 (##) #####-####"
        allowEmptyFormatting
        mask="_"
        type="tel"
        value={value}
        placeholder={placeholder || "Telefone"}
        className="
          w-full
          text-black
          px-3
          py-2
          h-[50px]
          text-base
          border border-gray-300
          rounded-md
          focus:outline-none
          focus:ring-2
          focus:ring-blue-500
          focus:border-transparent
        "
        onValueChange={(v) =>
          onChange({
            target: { name, value: v.value },
          } as any)
        }
      />
    </div>
  );
}
